import '../assets/css/homePageTeste.css'
import { useEffect, useState } from 'react'
import { BuscaFotoFashion, consultaVendedoraProxima, RegistrarCliqueRevendedora } from './funcionalidades/bancoGet'
import RevendFotoPadrao from '../assets/imgs/menuLogo.png'

/* Wordmark Babita (positivo preto sobre creme) - usa currentColor */
const Wordmark = ({ className }) => (
    <svg className={className} viewBox="0 0 700 222" fill="currentColor" xmlns="http://www.w3.org/2000/svg" aria-label="Babita">
        <path d="M317.751 76.4979C324.431 73.551 330.084 68.6851 333.992 62.5183C337.9 56.3514 339.887 49.1621 339.7 41.8636C339.7 16.0558 327.099 0 302.413 0H243.828V124.509H258.561V14.7455H301.278C304.166 14.7455 324.094 14.9606 324.094 41.8636C324.094 54.6274 316.63 63.9753 300.913 69.1447V83.8772C300.913 83.8772 340.515 92.1756 340.515 130.76C340.515 184.866 291.872 185.831 270.595 174.254C270.236 174.039 268.711 173.204 268.756 173.237C268.694 173.212 268.633 173.184 268.574 173.152C268.411 173.087 268.293 173.152 268.574 173.367C268.854 173.582 269.643 174.254 270.014 174.599C287.354 189.201 355.847 193.054 355.847 131.484C355.9 119.516 352.272 107.821 345.455 97.9847C338.639 88.1479 328.963 80.6446 317.738 76.4914"/>
        <path d="M581.847 0H567.102L528.035 186.6H542.767L555.003 128.192H607.433C627.563 173.439 655.333 214.755 690.874 220.882C693.859 221.378 700 222.577 700 221.665C700 220.974 695.469 220.498 693.273 219.663C624.499 193.406 581.847 0 581.847 0ZM557.812 114.783L574.924 33.0893C582.097 60.8674 591.051 88.155 601.729 114.783H557.812Z"/>
        <path d="M537.63 14.7455V0H417.684V14.7455H470.265V191.255H485.011V14.7455H537.63Z"/>
        <path d="M394.79 0H380.058V191.255H394.79V0Z"/>
        <path d="M73.9034 76.4979C80.5783 73.5471 86.2258 68.6794 90.129 62.5129C94.0323 56.3464 96.0152 49.1592 95.8261 41.8636C95.8717 16.0623 83.2709 0 58.5843 0H0V124.509H14.7324V14.7455H57.4696C60.3574 14.7455 80.2853 14.9606 80.2853 41.8636C80.2853 54.6274 72.8213 63.9753 57.1045 69.1447V83.8772C57.1045 83.8772 96.7061 92.1756 96.7061 130.76C96.7061 184.866 48.0825 185.831 26.7857 174.254C26.4271 174.039 24.9018 173.204 24.9474 173.237C24.8848 173.212 24.8239 173.184 24.7649 173.152C24.6019 173.087 24.4845 173.152 24.7649 173.367C25.0452 173.582 25.8144 174.254 26.2055 174.599C43.5455 189.201 112.038 193.054 112.038 131.484C112.081 119.514 108.445 107.82 101.624 97.9841C94.8017 88.1483 85.1229 80.6456 73.8969 76.4914"/>
        <path d="M175.733 0H160.988L121.94 186.6H136.673L148.895 128.192H201.326C221.489 173.439 249.265 214.755 284.766 220.882C287.752 221.378 293.893 222.577 293.893 221.665C293.893 220.974 289.362 220.498 287.165 219.663C218.373 193.406 175.733 0 175.733 0ZM151.731 114.783L168.81 33.0828C175.986 60.8586 184.935 88.1457 195.603 114.776L151.731 114.783Z"/>
    </svg>
)

const WppIcon = () => (
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <path d="M.057 24l1.687-6.163a11.867 11.867 0 0 1-1.587-5.946C.16 5.335 5.495 0 12.05 0a11.82 11.82 0 0 1 8.413 3.488 11.82 11.82 0 0 1 3.48 8.414c-.003 6.557-5.338 11.892-11.893 11.892a11.9 11.9 0 0 1-5.688-1.448L.057 24zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.884a9.86 9.86 0 0 0 1.513 5.26l-.999 3.648 3.785-.607zm11.387-5.464c-.074-.124-.272-.198-.57-.347-.297-.149-1.758-.868-2.031-.967-.272-.099-.47-.149-.669.149-.198.297-.768.967-.941 1.165-.173.198-.347.223-.644.074-.297-.149-1.255-.462-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.521.151-.172.2-.296.3-.495.099-.198.05-.372-.025-.521-.075-.148-.669-1.611-.916-2.206-.242-.579-.487-.501-.669-.51l-.57-.01c-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.095 3.2 5.076 4.487.709.306 1.263.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413z"/>
    </svg>
)

function capitalizeEachWord(string) {
    if (typeof string !== 'string' || string.length === 0) return ''
    return string.split(' ').map(w => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase()).join(' ')
}

const VendedoraCard = ({ item }) => {
    // item: [NOME, CEP, TELEFONE, CELULAR, ENDERECO, NUMERO, BAIRRO, CIDADE, FOTO]
    const [userImage, setUserImage] = useState('')

    useEffect(() => {
        if (item && item[8]) {
            BuscaFotoFashion({ IMG: item[8] }).then(resp => {
                if (resp && !resp.Error) setUserImage(resp)
            })
        }
    }, [item])

    if (!item) return null

    const nome = capitalizeEachWord(item[0].split(' ').slice(0, 4).join(' '))
    const primeiro = capitalizeEachWord(item[0].trim().split(' ')[0])
    const fundo = userImage
        ? "url('data:image/png;base64," + userImage + "')"
        : "url('" + RevendFotoPadrao + "')"
    const wppLink = item[3]
        ? "https://wa.me/55" + item[3].replace(/\s+/g, '') + "?text=Ol%C3%A1+" + primeiro + "%21+Encontrei+seu+contato+no+localizador+de+revendedores+e+fiquei+interessado+nos+produtos+da+Babita%21+Gostaria+de+saber+mais+e+fazer+uma+compra.+Poderia+me+ajudar%3F"
        : null

    return (
        <div className="tp-vend">
            <div className="tp-vend-foto" style={{ backgroundImage: fundo }} />
            <div className="tp-vend-info">
                <div className="tp-vend-label">Revendedora</div>
                <div className="tp-vend-nome">{nome}</div>
            </div>
            {wppLink && (
                <a className="tp-wpp" href={wppLink} target="_blank" rel="noreferrer" onClick={() => RegistrarCliqueRevendedora({ CPF: item[8] })}>
                    <WppIcon /><span>Conversar</span>
                </a>
            )}
        </div>
    )
}

export default function HomePage() {
    const [cep, setCep] = useState('')
    const [lista, setLista] = useState(null)
    const [loading, setLoading] = useState(false)
    const [verVendedoras, setVerVendedoras] = useState(false)
    const [pagina, setPagina] = useState(0)
    const porPagina = 3

    const buscar = () => {
        const limpo = cep.replace(/\D/g, '')
        if (limpo.length !== 8) {
            setLista([])
            setVerVendedoras(true)
            return
        }
        setLoading(true)
        consultaVendedoraProxima({ CEP: limpo }).then(resp => {
            setLoading(false)
            setPagina(0)
            if (resp && resp.NotFound) {
                setLista([])
            } else {
                setLista(resp)
            }
            setVerVendedoras(true)
        })
    }

    const novaBusca = () => {
        setVerVendedoras(false)
        setLista(null)
        setCep('')
    }

    const temMais = lista && lista.length > (pagina + 1) * porPagina
    const visiveis = lista ? lista.slice(pagina * porPagina, pagina * porPagina + porPagina) : []

    return (
        <div className="tp-page">
            <header className="tp-header">
                <Wordmark className="tp-logo" />
                <div className="tp-tagline">Encontre quem veste você de Babita</div>
            </header>

            {!verVendedoras ? (
                <section className="tp-card">
                    <h1 className="tp-title">Encontre uma revendedora perto de você</h1>
                    <p className="tp-subtitle">
                        Digite o seu CEP e descubra as revendedoras Babita mais próximas para uma
                        experiência de compra excepcional.
                    </p>
                    <div className="tp-field">
                        <input
                            className="tp-input"
                            type="text"
                            inputMode="numeric"
                            maxLength={9}
                            placeholder="00000-000"
                            value={cep}
                            onChange={e => setCep(e.target.value)}
                            onKeyDown={e => e.key === 'Enter' && buscar()}
                        />
                        <button className="tp-btn" onClick={buscar} disabled={loading}>
                            {loading ? 'Buscando...' : 'Buscar revendedoras'}
                        </button>
                    </div>
                </section>
            ) : (
                <section className="tp-card">
                    <div className="tp-results-head">
                        <h2 className="tp-title">
                            {lista && lista.length > 0 ? 'Revendedoras próximas' : 'Nada por perto'}
                        </h2>
                    </div>

                    {lista && lista.length > 0 ? (
                        <>
                            {visiveis.map((item, i) => (
                                <VendedoraCard key={pagina * porPagina + i} item={item} />
                            ))}
                            <div className="tp-actions">
                                {temMais && (
                                    <button className="tp-btn tp-btn--ghost" onClick={() => setPagina(pagina + 1)}>
                                        Ver mais revendedoras
                                    </button>
                                )}
                                <button className="tp-btn" onClick={novaBusca}>Buscar outro CEP</button>
                            </div>
                        </>
                    ) : (
                        <>
                            <p className="tp-feedback">
                                Nenhuma revendedora encontrada por perto. Tente outro CEP.
                            </p>
                            <div className="tp-actions">
                                <button className="tp-btn" onClick={novaBusca}>Tentar outro CEP</button>
                            </div>
                        </>
                    )}
                </section>
            )}

            <footer className="tp-footer">Babita - O melhor para quem vende moda</footer>
        </div>
    )
}
